import React, { useState } from "react"
import { useSelector } from "react-redux"
import { getIsUsa } from "reducers/userInfo"
import { useFormContext } from "react-hook-form"
import { Section, SingleShorty, TwoColumnRow } from "./Shared"
import L10n from "../../../lib/carrot-l10n"
import { CompleteUsaStateSelect } from "components/views/atoms/forms/FormUsaStateSelect"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { CompleteFormTextArea } from "components/views/atoms/forms/FormTextArea"
import { FlexContainer } from "@carrotfertility/carotene"
import { BodySmall } from "../atoms/Bodies"
import { InternationalAddress } from "../../InternationalAddress"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const Address1 = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormInput name="address1" label={l`client.accountSettings.address1Label`} errors={errors} ref={register} />
  )
}

const Address2 = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormInput name="address2" label={l`client.accountSettings.address2Label`} errors={errors} ref={register} />
  )
}

const City = () => {
  const { errors, register } = useFormContext()

  return <CompleteFormInput name="city" label={l`client.accountSettings.cityLabel`} errors={errors} ref={register} />
}

const State = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteUsaStateSelect name="state" label={l`client.accountSettings.stateLabel`} errors={errors} ref={register} />
  )
}

const Zip = () => {
  const { errors, register } = useFormContext()

  return <CompleteFormInput name="zip" label={l`client.accountSettings.zipLabel`} errors={errors} ref={register} />
}

const InternationalAddressWithTitle = () => {
  const { register, errors } = useFormContext()
  return (
    <Section title="Address">
      <InternationalAddress register={register} errors={errors} />
    </Section>
  )
}

const UsaAddress = () => (
  <Section title="Address">
    <TwoColumnRow left={<Address1 />} right={<Address2 />} />
    <TwoColumnRow left={<City />} right={<State />} />
    <SingleShorty>
      <Zip />
    </SingleShorty>
  </Section>
)

const Address = () => (useSelector(getIsUsa) ? <UsaAddress /> : <InternationalAddressWithTitle />)

export default Address
